import { useAppStore, type Layout } from "../store/appStore";
import { Ico, LSIcon } from "./icons";
import { Avatar } from "./atoms";

export function TopBar() {
  const {
    workspaces, activeWorkspace, layout, setLayout, commits, team, me,
    openWorkspaceModal, openTeammate,
  } = useAppStore();
  const ws = workspaces.find((w) => w.id === activeWorkspace) ?? workspaces[0];

  // First commit by someone other than me — used as the inline badge.
  const teammateCommit = commits.find((c) => {
    const member = team.find((t) => t.displayName === c.user);
    return member && member.supabaseId !== me?.supabaseId;
  });

  return (
    <header className="topbar">
      <div className="topbar-context">
        <span className="workspace">{ws?.name ?? "—"}</span>
        {ws?.branch && (
          <>
            <span className="sep">·</span>
            <span className="branch"><Ico name="branch" size={12} />{ws.branch}</span>
          </>
        )}
      </div>

      {teammateCommit && (() => {
        const member = team.find((t) => t.displayName === teammateCommit.user);
        return (
          <button className="git-badge" onClick={() => member && openTeammate(member.supabaseId)}>
            <span className="pulse" />
            {member && <Avatar member={member} size={16} showPresence={false} />}
            <span>
              {teammateCommit.user}: neuer Commit auf{" "}
              <span style={{ fontFamily: "var(--font-mono)", color: "var(--color-fg)" }}>
                {teammateCommit.branch}
              </span>
            </span>
          </button>
        );
      })()}

      <div className="topbar-spacer" />

      <div className="layout-switcher" role="tablist" aria-label="Layout">
        {(["2x2", "1x2", "1x3", "full"] as Layout[]).map((k) => (
          <button
            key={k}
            className={layout === k ? "active" : ""}
            onClick={() => setLayout(k)}
            title={k === "full" ? "Fullscreen" : k}
          >
            <LSIcon kind={k} />
          </button>
        ))}
      </div>

      <button className="kbar">
        <Ico name="search" size={13} />
        <span>Suchen oder Befehl…</span>
        <span className="kbd">⌘K</span>
      </button>

      <button
        className="icon-btn"
        onClick={openWorkspaceModal}
        title="Workspace-Manager"
        style={{ width: 28, height: 28 }}
      >
        <Ico name="folder" size={15} />
      </button>
    </header>
  );
}
